import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ems-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent implements OnInit {
  // Header title
  // Required: Title
  @Input() headerTitle = 'Title';

  // Header Subtitle
  // Optional: Renders next to the title, and slightly de-emphisized
  @Input() subtitle = null;

  // Header  Caption
  // Optional: Renders small, meta information to support the title
  @Input() caption = null;

  constructor() {}

  ngOnInit() {}
}
